import { forwardRef, createElement } from 'react';

function IconSettingsSolid(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M13 2a1 1 0 011 1v1.77a7.44 7.44 0 011.698.703l1.252-1.251a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-1.251 1.252c.3.53.538 1.099.703 1.698H21a1 1 0 011 1v2a1 1 0 01-1 1h-1.77a7.454 7.454 0 01-.703 1.698l1.251 1.252a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-1.252-1.251a7.47 7.47 0 01-1.697.703L14 21a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1.77a7.454 7.454 0 01-1.698-.703L7.05 19.778a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l1.251-1.252A7.454 7.454 0 014.77 14H3a1 1 0 01-1-1v-2a1 1 0 011-1h1.77a7.44 7.44 0 01.703-1.698L4.222 7.05a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0l1.252 1.251c.53-.3 1.099-.538 1.698-.703V3a1 1 0 011-1h2zm-1 6a4 4 0 100 8 4 4 0 000-8z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var SettingsSolid = /*#__PURE__*/forwardRef(IconSettingsSolid);

export default SettingsSolid;
//# sourceMappingURL=SettingsSolid.js.map
